<spinner [isRunning]="showSpinner"></spinner>
<div #maincontainer class="main-container search scroll-container">
  <mat-progress-bar *ngIf="isLoadingMoreRecords" mode="indeterminate" class="top-progress-bar"></mat-progress-bar>

  <form novalidate [formGroup]="searchForm">
    <!-- Desktop: mismos patrones que clearance-list (legacy + mat-form-field appearance="fill") -->
    <div class="header-bar desktop-header">
      <div class="header-items">
        <div class="search-header-filters">
          <mat-checkbox color="accent" *ngIf="isClearanceUser" formControlName="currentProject" class="search-filter-checkbox">Current Project Only</mat-checkbox>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Search by Keyword</mat-label>
              <input matInput formControlName="keyword" type="text" minlength="2">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('keyword')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action" *ngIf="isClearanceUser">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Project Name</mat-label>
              <input matInput formControlName="projectName" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('projectName')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Filter by Status</mat-label>
              <mat-select formControlName="status" multiple (selectionChange)="statusFilterChanged($event.value)">
                <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{ stat.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('status')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Tags</mat-label>
              <mat-select formControlName="tags" multiple (selectionChange)="tagsFilterChanged($event.value)">
                <mat-option *ngFor="let tag of tagsLookup" [value]="tag.name">{{ tag.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('tags')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Copyright/Owner</mat-label>
              <input matInput formControlName="copyright" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('copyright')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Artist/Author</mat-label>
              <input matInput formControlName="author" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('author')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action" *ngIf="isClearanceUser">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Report Group</mat-label>
              <input matInput formControlName="reportGroup" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('reportGroup')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Season</mat-label>
              <input matInput formControlName="season" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('season')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="filter-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Episode</mat-label>
              <input matInput formControlName="episode" type="text">
            </mat-form-field>
            <button mat-icon-button type="button" (click)="clearField('episode')" matTooltip="clear search" matTooltipPosition="below">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Deadline</mat-label>
            <input matInput [matDatepicker]="deadlinePickerDesktop" formControlName="deadline">
            <mat-datepicker-toggle matSuffix [for]="deadlinePickerDesktop"></mat-datepicker-toggle>
            <mat-datepicker #deadlinePickerDesktop></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Submission Date</mat-label>
            <input matInput [matDatepicker]="createdDatePickerDesktop" formControlName="createdDate">
            <mat-datepicker-toggle matSuffix [for]="createdDatePickerDesktop"></mat-datepicker-toggle>
            <mat-datepicker #createdDatePickerDesktop></mat-datepicker>
          </mat-form-field>

          <div class="sort-with-action">
            <mat-form-field appearance="fill" class="filter-field-grow">
              <mat-label>Sort By</mat-label>
              <mat-select formControlName="sortBy" (selectionChange)="filterChanged('sortBy')">
                <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="filterChanged('sortOrder')" matTooltip="sort direction" matTooltipPosition="below">
              <mat-icon>{{ sortOrderIcon }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="header-actions">
          <div class="header-actions-left">
            <ng-container *ngIf="!hideTotalRows()">
              <mat-form-field appearance="fill" class="page-size-field">
                <mat-label>Page size</mat-label>
                <mat-select formControlName="pageSize" (selectionChange)="onPageSizeChange()">
                  <mat-option *ngFor="let option of [20,50]" [value]="option">{{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
              <span class="pagination-text">{{ getPaginationText() }}</span>
            </ng-container>
          </div>
          <span class="spacer"></span>
          <div class="header-actions-right">
            <ng-container *ngIf="!hideTotalRows()">
              <mat-checkbox color="accent" [checked]="allItemsSelected" (change)="selectAllItems($event)"
                matTooltip="For only items on displayed on this page" matTooltipPosition="below">
                {{ getSelectText() }}
              </mat-checkbox>
              <button mat-button type="button" class="search-header-action-btn" (click)="generateReport()">Export List</button>
            </ng-container>
            <div class="action-items" *ngIf="anyItemSelected && !_authService.readOnly">
              <bulk-bar [backActionVisible]="true" [projectId]="searchProjectId" [itemList]="itemSelectedList"
                [isClearanceUser]="isClearanceUser" [readOnly]="_authService.readOnly"
                (ModalInitializationRequested)="onModalInitRequest($event)"
                (downloadImagesRequested)="downloadImages()"
                (selectionCancelled)="clearItemSelection()"></bulk-bar>
            </div>
            <ng-container *ngIf="!anyItemSelected">
              <button mat-button type="button" class="search-header-action-btn" data-search-clear (click)="close()">Clear</button>
              <button mat-button type="button" class="search-header-action-btn" data-search-apply (click)="searchItems()" [disabled]="!canExecuteSearch()">Apply</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile: mismo patrón que clearance-list -->
    <div class="header-bar mobile-header">
      <div class="mobile-header-row">
        <span class="mobile-total-label" *ngIf="!hideTotalRows()">{{ totalRowsLabel() }}</span>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="showMobileFilters = !showMobileFilters" matTooltip="expand filters" matTooltipPosition="below">
          <mat-icon>search</mat-icon>
        </button>
        <div class="action-items" *ngIf="anyItemSelected && !_authService.readOnly">
          <bulk-bar [backActionVisible]="false" [projectId]="searchProjectId" [itemList]="itemSelectedList"
            [isClearanceUser]="isClearanceUser" (ModalInitializationRequested)="onModalInitRequest($event)"
            (downloadImagesRequested)="downloadImages()"></bulk-bar>
        </div>
      </div>

      <div class="mobile-filters search-mobile-filters" *ngIf="showMobileFilters">
        <mat-checkbox color="accent" *ngIf="isClearanceUser" formControlName="currentProject">Current Project Only</mat-checkbox>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Search by Keyword</mat-label>
            <input matInput formControlName="keyword" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('keyword')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row" *ngIf="isClearanceUser">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Project Name</mat-label>
            <input matInput formControlName="projectName" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('projectName')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Filter by Status</mat-label>
            <mat-select formControlName="status" multiple (selectionChange)="statusFilterChanged($event.value)">
              <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{ stat.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('status')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Tags</mat-label>
            <mat-select formControlName="tags" multiple (selectionChange)="tagsFilterChanged($event.value)">
              <mat-option *ngFor="let tag of tagsLookup" [value]="tag.name">{{ tag.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('tags')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Copyright/Owner</mat-label>
            <input matInput formControlName="copyright" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('copyright')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Author/Artist</mat-label>
            <input matInput formControlName="author" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('author')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Season</mat-label>
            <input matInput formControlName="season" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('season')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Episode</mat-label>
            <input matInput formControlName="episode" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('episode')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <div class="filter-with-action mobile-filter-row" *ngIf="isClearanceUser">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Report Group Name</mat-label>
            <input matInput formControlName="reportGroup" type="text">
          </mat-form-field>
          <button mat-icon-button type="button" (click)="clearField('reportGroup')" matTooltip="clear search"><mat-icon>clear</mat-icon></button>
        </div>

        <mat-form-field appearance="fill" class="filter-field-grow">
          <mat-label>Deadline</mat-label>
          <input matInput [matDatepicker]="deadlinePickerMobile" formControlName="deadline">
          <mat-datepicker-toggle matSuffix [for]="deadlinePickerMobile"></mat-datepicker-toggle>
          <mat-datepicker #deadlinePickerMobile></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="filter-field-grow">
          <mat-label>Submission Date</mat-label>
          <input matInput [matDatepicker]="createdDatePickerMobile" formControlName="createdDate">
          <mat-datepicker-toggle matSuffix [for]="createdDatePickerMobile"></mat-datepicker-toggle>
          <mat-datepicker #createdDatePickerMobile></mat-datepicker>
        </mat-form-field>

        <div class="sort-with-action mobile-filter-row">
          <mat-form-field appearance="fill" class="filter-field-grow">
            <mat-label>Sort By</mat-label>
            <mat-select formControlName="sortBy" (selectionChange)="filterChanged('sortBy')">
              <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button type="button" (click)="filterChanged('sortOrder')" matTooltip="sort direction"><mat-icon>{{ sortOrderIcon }}</mat-icon></button>
        </div>

        <div class="mobile-actions-row" *ngIf="!hideTotalRows()">
          <mat-form-field appearance="fill" class="page-size-field">
            <mat-label>Page size</mat-label>
            <mat-select formControlName="pageSize" (selectionChange)="onPageSizeChange()">
              <mat-option *ngFor="let option of [20,50]" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="mobile-actions-bottom">
          <mat-checkbox color="accent" [checked]="allItemsSelected" (change)="selectAllItems($event)">Select</mat-checkbox>
          <button mat-button type="button" class="search-header-action-btn" (click)="generateReport()">Export List</button>
          <span class="spacer"></span>
          <button mat-button type="button" class="search-header-action-btn" data-search-clear (click)="close($event)">Clear</button>
          <button mat-button type="button" class="search-header-action-btn" data-search-apply (click)="searchItems()" [disabled]="!canExecuteSearch()">Apply</button>
        </div>
      </div>
    </div>
  </form>

  <div class="subheader" *ngIf="itemList.length <= 0">
    <mat-icon *ngIf="showNoResultsIcon" class="subheader-icon">error</mat-icon>
    <span>{{ searchMessage }}</span>
  </div>

  <div class="cards-grid animated fadeIn">
    <mat-card class="list-view-card" *ngFor="let item of itemList">
      <mat-card-content (click)="openItemDetails(item.id, item.projectId, item.projectName)">
        <div class="card-layout">
          <div class="list-thumbnail">
            <mat-icon *ngIf="!item.defaultImage" class="no-image-icon">image</mat-icon>
            <img *ngIf="item.defaultImage" [src]="item.defaultImage.fullUrl" alt="" (load)="imageLoadFinished($event)" />
          </div>

          <div class="item-details">
            <div class="title nowrapping">
              {{item.name}}
            </div>
            <div class="project nowrapping">{{item.projectName}}</div>
            <div class="status nowrapping" [ngClass]="item.statusClass">{{item.status}}</div>

            <div class="detail-meta">
              <div class="detail-meta-col detail-meta-col-left">
                <div class="copyright nowrapping" matTooltip="copyright/owner" matTooltipPosition="below">
                  <mat-icon>copyright</mat-icon><span>{{item.copyrightInfo}}</span>
                </div>
                <div class="author nowrapping" matTooltip="artist/author" matTooltipPosition="left">
                  <mat-icon>accessibility</mat-icon><span>{{item.artistAuthorName}}</span>
                </div>
                <div *ngIf="isClearanceUser" class="reportgroup nowrapping" matTooltip="report group name" matTooltipPosition="left">
                  <mat-icon>wb_incandescent</mat-icon><span>{{item.reportGroupName}}</span>
                </div>
              </div>
              <div class="detail-meta-col detail-meta-col-right">
                <div class="deadline nowrapping" matTooltip="deadline" matTooltipPosition="left">
                  <mat-icon>alarm_on</mat-icon><span>{{item.deadline}}</span>
                </div>
                <div class="deadline nowrapping" *ngIf="item.season" matTooltip="season" matTooltipPosition="below">
                  <mat-icon>movie</mat-icon><span>{{item.season}}</span>
                </div>
                <div class="deadline nowrapping" *ngIf="item.episode" matTooltip="episode" matTooltipPosition="left">
                  <mat-icon>theaters</mat-icon><span>{{item.episode}}</span>
                </div>
                <div class="item-number nowrapping" matTooltip="unique id" matTooltipPosition="left">
                  <span class="unique-id">#</span><span>{{item.ciUniqueId}}</span>
                </div>
                <div class="item-number nowrapping" matTooltip="submission date" matTooltipPosition="left">
                  <mat-icon>alarm_add</mat-icon><span>{{item.createdDate}}</span>
                </div>
              </div>
            </div>

            <div class="tag-list nowrapping hoverable">
              <div class="tag" *ngFor="let tag of item.tags">{{tag.tagName}}</div>
            </div>
          </div>

          <div class="item-select" *ngIf="!_authService.readOnly || moreTitlesVisible(item)">
            <a *ngIf="moreTitlesVisible(item)" class="anchor aka-moretitles"
               [matTooltip]="stringTitle(item)" matTooltipPosition="below"
               (click)="showMoreTitles(item); stopPropagation($event)">
              <mat-icon class="more-titles-icon">link</mat-icon>
            </a>
            <mat-checkbox *ngIf="!_authService.readOnly" color="accent" id="{{item.id}}" [(ngModel)]="item.isSelected"
              (ngModelChange)="updateItemSelected(item, $event)"
              (click)="stopPropagation($event)"></mat-checkbox>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="show-on-medium-and-down hide-on-large-only" style="justify-content: center;display: flex; margin-top: 10%;"></div>
  <div *ngIf="totalItems > 0 " class="animated fadeIn" style="justify-content: center;display: flex;"><custom-paginator [pageSize]="pageSize" [totalItems]="totalItems" [currentPage]="currentPage" [callback]="loadRecords"></custom-paginator></div>

</div>
<div class="other-titles-overlay" *ngIf="showOtherTitlesModal" (click)="closeMoreTitlesModal()">
  <div class="other-titles-modal" (click)="stopPropagation($event)">
    <h5>Other Titles</h5>
    <p>{{ stringTitle(selectedItem) }}</p>
    <div class="other-titles-actions">
      <button mat-button (click)="closeMoreTitlesModal($event)">Close</button>
    </div>
  </div>
</div>
<bulk-actions #bulkAction [modalId]="currentBulkModalId" [projectId]="searchProjectId || projectIdFromSelectedItems" [itemList]="itemList" [dataList]="bulkDataList"
  [isClearanceUser]="isClearanceUser"></bulk-actions>
